import React from 'react';

import { ILoaderProps } from './Loader.types';

import './Loader.scss';

export default function Loader(props: ILoaderProps) {
  return (
    <div
      data-testid='Loader'
      className={'flc_loader ' + (props.className ? props.className : '')}>
      <div className='dot-loader'></div>
      <div className='dot-loader'></div>
      <div className='dot-loader'></div>
    </div>
  );
}
